import { default as adm7Ts2y43LjuMeta } from "/onenews/pages/adm.vue?macro=true";
import { default as indexdwmxbZ3d9HMeta } from "/onenews/pages/advertise/index.vue?macro=true";
import { default as ncitUCB2xBjeMeta } from "/onenews/pages/combo/a/nc.vue?macro=true";
import { default as indexmSSPfj03JlMeta } from "/onenews/pages/contact/index.vue?macro=true";
import { default as g2hT4SiECwaMeta } from "/onenews/pages/g.vue?macro=true";
import { default as index4YjwaxOOWsMeta } from "/onenews/pages/index.vue?macro=true";
import { default as indexMsJUvfNRdEMeta } from "/onenews/pages/p/index.vue?macro=true";
import { default as indexWqIk9Vltv0Meta } from "/onenews/pages/p/nc/index.vue?macro=true";
import { default as indexzlzEfUTfXhMeta } from "/onenews/pages/p/nc/tab/a/index.vue?macro=true";
import { default as index7xyTxoBsHlMeta } from "/onenews/pages/partnerships/index.vue?macro=true";
import { default as indexrfPUmNxXvqMeta } from "/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexvCfdi963H3Meta } from "/onenews/pages/summary/index.vue?macro=true";
import { default as index4FzbGNt0iqMeta } from "/onenews/pages/tab/v5/a/nc/index.vue?macro=true";
import { default as ncdCogR8Ri2zMeta } from "/onenews/pages/tab/v5/nc.vue?macro=true";
import { default as indexw8chQ7d3ERMeta } from "/onenews/pages/terms/index.vue?macro=true";
import { default as ay_45test4Y6EcmE3yTMeta } from "/onenews/pages/v5/ay-test.vue?macro=true";
import { default as indexV8uUTGDzgcMeta } from "/onenews/pages/v5/index.vue?macro=true";
import { default as indexS7qQ7DUUaPMeta } from "/onenews/pages/v5/nc/index.vue?macro=true";
import { default as ncO2piRTLwHvMeta } from "/onenews/pages/v6/nc.vue?macro=true";
import { default as indexvdBirgTbzMMeta } from "/onenews/pages/v8/index.vue?macro=true";
export default [
  {
    name: adm7Ts2y43LjuMeta?.name ?? "adm",
    path: adm7Ts2y43LjuMeta?.path ?? "/adm",
    meta: adm7Ts2y43LjuMeta || {},
    alias: adm7Ts2y43LjuMeta?.alias || [],
    redirect: adm7Ts2y43LjuMeta?.redirect,
    component: () => import("/onenews/pages/adm.vue").then(m => m.default || m)
  },
  {
    name: indexdwmxbZ3d9HMeta?.name ?? "advertise",
    path: indexdwmxbZ3d9HMeta?.path ?? "/advertise",
    meta: indexdwmxbZ3d9HMeta || {},
    alias: indexdwmxbZ3d9HMeta?.alias || [],
    redirect: indexdwmxbZ3d9HMeta?.redirect,
    component: () => import("/onenews/pages/advertise/index.vue").then(m => m.default || m)
  },
  {
    name: ncitUCB2xBjeMeta?.name ?? "combo-a-nc",
    path: ncitUCB2xBjeMeta?.path ?? "/combo/a/nc",
    meta: ncitUCB2xBjeMeta || {},
    alias: ncitUCB2xBjeMeta?.alias || [],
    redirect: ncitUCB2xBjeMeta?.redirect,
    component: () => import("/onenews/pages/combo/a/nc.vue").then(m => m.default || m)
  },
  {
    name: indexmSSPfj03JlMeta?.name ?? "contact",
    path: indexmSSPfj03JlMeta?.path ?? "/contact",
    meta: indexmSSPfj03JlMeta || {},
    alias: indexmSSPfj03JlMeta?.alias || [],
    redirect: indexmSSPfj03JlMeta?.redirect,
    component: () => import("/onenews/pages/contact/index.vue").then(m => m.default || m)
  },
  {
    name: g2hT4SiECwaMeta?.name ?? "g",
    path: g2hT4SiECwaMeta?.path ?? "/g",
    meta: g2hT4SiECwaMeta || {},
    alias: g2hT4SiECwaMeta?.alias || [],
    redirect: g2hT4SiECwaMeta?.redirect,
    component: () => import("/onenews/pages/g.vue").then(m => m.default || m)
  },
  {
    name: index4YjwaxOOWsMeta?.name ?? "index",
    path: index4YjwaxOOWsMeta?.path ?? "/",
    meta: index4YjwaxOOWsMeta || {},
    alias: index4YjwaxOOWsMeta?.alias || [],
    redirect: index4YjwaxOOWsMeta?.redirect,
    component: () => import("/onenews/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexMsJUvfNRdEMeta?.name ?? "p",
    path: indexMsJUvfNRdEMeta?.path ?? "/p",
    meta: indexMsJUvfNRdEMeta || {},
    alias: indexMsJUvfNRdEMeta?.alias || [],
    redirect: indexMsJUvfNRdEMeta?.redirect,
    component: () => import("/onenews/pages/p/index.vue").then(m => m.default || m)
  },
  {
    name: indexWqIk9Vltv0Meta?.name ?? "p-nc",
    path: indexWqIk9Vltv0Meta?.path ?? "/p/nc",
    meta: indexWqIk9Vltv0Meta || {},
    alias: indexWqIk9Vltv0Meta?.alias || [],
    redirect: indexWqIk9Vltv0Meta?.redirect,
    component: () => import("/onenews/pages/p/nc/index.vue").then(m => m.default || m)
  },
  {
    name: indexzlzEfUTfXhMeta?.name ?? "p-nc-tab-a",
    path: indexzlzEfUTfXhMeta?.path ?? "/p/nc/tab/a",
    meta: indexzlzEfUTfXhMeta || {},
    alias: indexzlzEfUTfXhMeta?.alias || [],
    redirect: indexzlzEfUTfXhMeta?.redirect,
    component: () => import("/onenews/pages/p/nc/tab/a/index.vue").then(m => m.default || m)
  },
  {
    name: index7xyTxoBsHlMeta?.name ?? "partnerships",
    path: index7xyTxoBsHlMeta?.path ?? "/partnerships",
    meta: index7xyTxoBsHlMeta || {},
    alias: index7xyTxoBsHlMeta?.alias || [],
    redirect: index7xyTxoBsHlMeta?.redirect,
    component: () => import("/onenews/pages/partnerships/index.vue").then(m => m.default || m)
  },
  {
    name: indexrfPUmNxXvqMeta?.name ?? "privacy-policy",
    path: indexrfPUmNxXvqMeta?.path ?? "/privacy-policy",
    meta: indexrfPUmNxXvqMeta || {},
    alias: indexrfPUmNxXvqMeta?.alias || [],
    redirect: indexrfPUmNxXvqMeta?.redirect,
    component: () => import("/onenews/pages/privacy-policy/index.vue").then(m => m.default || m)
  },
  {
    name: indexvCfdi963H3Meta?.name ?? "summary",
    path: indexvCfdi963H3Meta?.path ?? "/summary",
    meta: indexvCfdi963H3Meta || {},
    alias: indexvCfdi963H3Meta?.alias || [],
    redirect: indexvCfdi963H3Meta?.redirect,
    component: () => import("/onenews/pages/summary/index.vue").then(m => m.default || m)
  },
  {
    name: index4FzbGNt0iqMeta?.name ?? "tab-v5-a-nc",
    path: index4FzbGNt0iqMeta?.path ?? "/tab/v5/a/nc",
    meta: index4FzbGNt0iqMeta || {},
    alias: index4FzbGNt0iqMeta?.alias || [],
    redirect: index4FzbGNt0iqMeta?.redirect,
    component: () => import("/onenews/pages/tab/v5/a/nc/index.vue").then(m => m.default || m)
  },
  {
    name: ncdCogR8Ri2zMeta?.name ?? "tab-v5-nc",
    path: ncdCogR8Ri2zMeta?.path ?? "/tab/v5/nc",
    meta: ncdCogR8Ri2zMeta || {},
    alias: ncdCogR8Ri2zMeta?.alias || [],
    redirect: ncdCogR8Ri2zMeta?.redirect,
    component: () => import("/onenews/pages/tab/v5/nc.vue").then(m => m.default || m)
  },
  {
    name: indexw8chQ7d3ERMeta?.name ?? "terms",
    path: indexw8chQ7d3ERMeta?.path ?? "/terms",
    meta: indexw8chQ7d3ERMeta || {},
    alias: indexw8chQ7d3ERMeta?.alias || [],
    redirect: indexw8chQ7d3ERMeta?.redirect,
    component: () => import("/onenews/pages/terms/index.vue").then(m => m.default || m)
  },
  {
    name: ay_45test4Y6EcmE3yTMeta?.name ?? "v5-ay-test",
    path: ay_45test4Y6EcmE3yTMeta?.path ?? "/v5/ay-test",
    meta: ay_45test4Y6EcmE3yTMeta || {},
    alias: ay_45test4Y6EcmE3yTMeta?.alias || [],
    redirect: ay_45test4Y6EcmE3yTMeta?.redirect,
    component: () => import("/onenews/pages/v5/ay-test.vue").then(m => m.default || m)
  },
  {
    name: indexV8uUTGDzgcMeta?.name ?? "v5",
    path: indexV8uUTGDzgcMeta?.path ?? "/v5",
    meta: indexV8uUTGDzgcMeta || {},
    alias: indexV8uUTGDzgcMeta?.alias || [],
    redirect: indexV8uUTGDzgcMeta?.redirect,
    component: () => import("/onenews/pages/v5/index.vue").then(m => m.default || m)
  },
  {
    name: indexS7qQ7DUUaPMeta?.name ?? "v5-nc",
    path: indexS7qQ7DUUaPMeta?.path ?? "/v5/nc",
    meta: indexS7qQ7DUUaPMeta || {},
    alias: indexS7qQ7DUUaPMeta?.alias || [],
    redirect: indexS7qQ7DUUaPMeta?.redirect,
    component: () => import("/onenews/pages/v5/nc/index.vue").then(m => m.default || m)
  },
  {
    name: ncO2piRTLwHvMeta?.name ?? "v6-nc",
    path: ncO2piRTLwHvMeta?.path ?? "/v6/nc",
    meta: ncO2piRTLwHvMeta || {},
    alias: ncO2piRTLwHvMeta?.alias || [],
    redirect: ncO2piRTLwHvMeta?.redirect,
    component: () => import("/onenews/pages/v6/nc.vue").then(m => m.default || m)
  },
  {
    name: indexvdBirgTbzMMeta?.name ?? "v8",
    path: indexvdBirgTbzMMeta?.path ?? "/v8",
    meta: indexvdBirgTbzMMeta || {},
    alias: indexvdBirgTbzMMeta?.alias || [],
    redirect: indexvdBirgTbzMMeta?.redirect,
    component: () => import("/onenews/pages/v8/index.vue").then(m => m.default || m)
  }
]